import { Check, ExternalLink, ShieldCheck } from "lucide-react";
import { QuoteButton } from "../home/CtaButtons";
import { CompareLink } from "./InfoHero";

export const AdviceEndCta = ({ title, location, onderwerp, params }) => (
  <section aria-labelledby={`${location}-end-title`} className="section" data-testid={`${location}-end-cta`}>
    <div className="container-tight">
      <div className="relative overflow-hidden rounded-3xl bg-ink px-6 py-12 sm:px-12 sm:py-14 lg:px-16">
        <div className="hero-grid-dark absolute inset-0 opacity-60" aria-hidden="true" />
        <div className="relative grid items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <h2 id={`${location}-end-title`} className="h2 text-balance !text-white">{title}</h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">Beantwoord een paar korte vragen en ontvang een persoonlijke prijsindicatie. Foto's meesturen kan; u zit nergens aan vast.</p>
            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-[14px] text-slate-300">
              {["Vrijblijvend", "Kozijnen, glas en montage", "Persoonlijk advies"].map((t) => (
                <li key={t} className="inline-flex items-center gap-1.5"><Check className="h-4 w-4 text-[#7FD3D6]" aria-hidden="true" /> {t}</li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col gap-5 sm:items-start lg:col-span-5 lg:items-end">
            <QuoteButton location={`${location}-end`} onderwerp={onderwerp} params={params} className="w-full sm:w-auto" />
            <CompareLink location={`${location}-end`} dark />
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Bronvermelding + verantwoordelijke redactie + datum van inhoudelijke controle.
export const SourcesBox = ({ sources = [], reviewed, note }) => (
  <section aria-label="Bronnen en controle" className="section-tight pt-0" data-testid="sources-box">
    <div className="container-tight">
      <div className="flex flex-col gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-5 sm:flex-row sm:items-start sm:gap-6 sm:p-6">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-maas ring-1 ring-slate-200"><ShieldCheck className="h-5 w-5" aria-hidden="true" /></span>
        <div className="text-[14px] leading-relaxed text-slate-600">
          <p><strong className="text-ink">Redactie Maas Kozijn</strong> · inhoudelijk gecontroleerd in {reviewed}</p>
          {note && <p className="mt-1">{note}</p>}
          {sources.length > 0 && (
            <ul className="mt-2 flex flex-wrap gap-x-5 gap-y-1.5">
              {sources.map((s) => (
                <li key={s.href}><a href={s.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-medium text-maas hover:underline">{s.label} <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" /></a></li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  </section>
);
